//MEMBERSHIP PAGE component
//*******************************************************************
//*******************************************************************
//IMPORTS:
//EXTERNAL & PACKAGE
import $ from 'jquery'
import Popper from 'popper.js'
import React from 'react'
import {graphql, Link} from 'gatsby'
import Iframe from 'react-iframe'
//COMPONENT DEPENDENCIES
import Heading from '../components/heading'
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import PageHeader from '../components/PageHeader'
import FullWidthImage from '../components/FullWidthImage'
import TextBlock from '../components/textblock'
import Header from '../components/Header'
import Helmet from "react-helmet"
//*******************************************************************
//*******************************************************************     
const membershipPage = ({data}) => {

    const membership = data.members.edges
    
    return(
    
        <div>
            <Helmet>
            <title>NJCCIC Membership</title>
            <meta name="description" content="Become a NJCCIC member and receive our publications"/>
            </Helmet>
            <Heading/>
        
            <Navbar/>
        
            {membership.map(({ node: {page_title, image, introductory_text, body_text} }) => (
        
                <div class="container-fluid">
                
                    
                    <div class="container containerWidth">
                        
                        
                        
                        <Iframe src="https://cyber-nj.force.com/join"
                            width="100%"
                            height="2000px"
                            id="myId"
                            className="iframeBlock"
                            display="initial"
                            position="relative"/>

                        
                    </div> 
                    
                     <div class="container containerWidth">
                        
                        <div class="row">
                
                            <TextBlock elementClass="col-12 textPadding topBorder bottomBorder" id="callToActionBlock" dangerousClass="callToAction bodyText" text={body_text}/>
                            
                        </div>
                        
                    </div>
        
                    <FullWidthImage src={image}/>                    
        
                </div>
            
            ))}
        
            <Footer/>
            
        </div>   
    
    )
    
}

export const query = graphql`
    query {
        members: allButterPage(filter: {slug: { eq: "members" } }) {
            edges {
                node {
                    slug
                    seo_title
                    page_title 
                    introductory_text 
                    image 
                    body_text
                }
            }
        }
    }
`
export default membershipPage
